import React from "react";
import { useParams } from "react-router-dom";
import MarketingNav from "@/components/site/MarketingNav";
import Footer from "@/components/site/Footer";

const COMPANY_INFO = {
  name: "Draftwave Editorial Co.",
  address: "11642 Victory Blvd, Unit 2032, North Hollywood, CA 91606",
  email: "info@draftwave.online",
  domain: "draftwave.online",
};

const CONTENT = {
  terms: {
    title: "Terms of Service",
    body: [
      "By using Draftwave you agree to use the service for lawful, non-harmful content creation. You retain full commercial rights to every generation.",
      "Subscriptions are billed monthly via Stripe. You may cancel any time from the Billing page. Access continues until the end of the paid period.",
      "Draftwave uses third-party AI models (Anthropic, OpenAI, Google) and passes your prompts to those providers under industry-standard data handling terms.",
      "We reserve the right to suspend accounts that generate content that violates AI provider content policies, spam networks, or applicable law.",
      `Governing law: California, USA. Any dispute is handled by courts of competent jurisdiction in Los Angeles County. Contact: ${COMPANY_INFO.email}.`,
    ],
  },
  privacy: {
    title: "Privacy",
    body: [
      "We store your email, name and picture (from Google) plus a log of your prompts and generations. Your prompts are used only to serve you and are never sold.",
      "Payments are handled by Stripe. We never see or store your card number.",
      `We use PostHog for anonymous product analytics. You can request full deletion of your data by emailing ${COMPANY_INFO.email}.`,
      "We do not train models on your content.",
      `Data controller: ${COMPANY_INFO.name}, ${COMPANY_INFO.address}.`,
    ],
  },
  refund: {
    title: "Refund policy",
    body: [
      "All Draftwave subscriptions are month-to-month. You can cancel at any time from your Billing page — cancellation takes effect at the end of the current paid period.",
      "If you were charged in error or your account had a service outage that materially prevented use, email us within 14 days of the charge and we will issue a full refund to the original payment method.",
      "Because content generations consume AI credits that we pay for at the moment of generation, we do not offer partial refunds for unused generations within a paid period.",
      `Refund requests: ${COMPANY_INFO.email}. Response within one business day.`,
    ],
  },
};

export default function Legal() {
  const { doc } = useParams();
  const content = CONTENT[doc] || CONTENT.terms;

  return (
    <div className="min-h-screen bg-background" data-testid={`legal-${doc}-page`}>
      <MarketingNav />
      <article className="max-w-2xl mx-auto px-6 md:px-8 py-16 md:py-24">
        <div className="overline text-muted-foreground">Legal</div>
        <h1 className="font-serif-display text-5xl md:text-6xl leading-none tracking-tight mt-4">
          {content.title}
        </h1>
        <div className="rule-h my-10" />
        {content.body.map((p, i) => (
          <p key={i} className="mt-6 text-base md:text-lg text-foreground/90 leading-relaxed">
            {p}
          </p>
        ))}
        <div className="mt-14 border-t border-border pt-6 text-sm font-mono text-muted-foreground">
          <div className="overline text-[10px]">Company</div>
          <div className="mt-2">{COMPANY_INFO.name}</div>
          <div>{COMPANY_INFO.address}</div>
          <div>
            <a href={`mailto:${COMPANY_INFO.email}`} className="hover:text-primary">
              {COMPANY_INFO.email}
            </a>
          </div>
        </div>
        <p className="mt-10 text-xs font-mono uppercase tracking-widest text-muted-foreground">
          Last updated · {new Date().toLocaleDateString()}
        </p>
      </article>
      <Footer />
    </div>
  );
}
